const env = (
  (globalThis as { __YOLO_ENV__?: Record<string, string | undefined> }).__YOLO_ENV__ ??
  (typeof process !== 'undefined' ? (process.env as Record<string, string | undefined>) : {})
);

export const SITE_CONFIG = {
  brand: {
    name: 'YOLO Telecoms',
    tagline: 'B2B enterprise-grade IT, voice, and security for SMB and SME teams.',
    location: 'Bryanston, Sandton',
  },
  urls: {
    site: env['VITE_YOLO_SITE_URL'] ?? 'https://yolo.co.za',
    socialImage: env['VITE_YOLO_SOCIAL_IMAGE_URL'] ?? 'https://www.yolo.co.za/hubfs/Yolo.png',
    quote: env['VITE_YOLO_QUOTE_URL'],
    assessment: env['VITE_YOLO_ASSESSMENT_URL'],
    support: env['VITE_YOLO_SUPPORT_URL'],
    featureRequests: env['VITE_YOLO_FEATURES_URL'],
    voicePro: env['VITE_YOLO_VOICEPRO_URL'] ?? 'https://voicepro.yolo.co.za',
    mspAi: env['VITE_YOLO_MSP_AI_URL'] ?? 'https://msp-ai.yolo.co.za',
    linkedin: env['VITE_YOLO_LINKEDIN_URL'] ?? 'https://www.linkedin.com/company/yolo-telecoms',
    twitter: env['VITE_YOLO_TWITTER_URL'] ?? 'https://x.com/yolotelecoms',
  },
  api: {
    base: env['VITE_YOLO_API_URL'] ?? '/api/v1',
    payments: env['VITE_YOLO_PAYMENTS_API_URL'] ?? '/api/v1/payments',
  },
  pricing: {
    customerId: env['VITE_YOLO_CUSTOMER_ID'],
  },
};

export const resolveUrl = (value?: string): string => (value && value.trim().length ? value : '#');

export const resolveAbsoluteUrl = (value: string | undefined, base = SITE_CONFIG.urls.site): string => {
  if (!value) return base;
  try {
    return new URL(value, base).toString();
  } catch {
    return value;
  }
};
